import * as React from 'react';
import { SVGProps } from 'react';

const Icon3DMapSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 5 5 3v7.5l6 2.5V5Z" fill="var(--color-bg-system)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.923 1.2a3 3 0 0 1 2.154 0l4.962 1.908c.579.223.961.78.961 1.4v6.627a1.5 1.5 0 0 1-.961 1.4l-4.962 1.908a3 3 0 0 1-2.154 0l-4.961-1.908a1.5 1.5 0 0 1-.962-1.4V4.508a1.5 1.5 0 0 1 .962-1.4L6.923 1.2Zm1.795.933a1.998 1.998 0 0 0-.198-.064l-.02-.006v1.588l2.989 1.131 1.947-.834-4.718-1.815Zm-1.436 0c.072-.027.144-.05.218-.07v1.21l-1.602-.607 1.384-.533ZM5.5 3.585l4.664 1.765L8 6.273l-2.5-1.07V3.586Zm-1-.379-.003-.001-1.933.743 1.936.828v-1.57Zm0 2.66L2 4.793v6.055l2.5-1.071V5.865Zm1 4.303 2 .754V7.15l-2-.857v3.875Zm6-4.304L14 4.794v6.055l-2.5-1.071V5.865Zm-1 .429-2 .857v4.15l2 .757V6.294Zm1 6.143.004.001 1.932-.743-1.936-.83v1.572Zm-3-.066 1.602.606-1.384.533c-.072.027-.144.05-.218.07v-1.21Zm-1-.38v1.588a1.985 1.985 0 0 1-.218-.07l-4.718-1.814 1.947-.834L7.5 11.99Z"
      fill="var(--color-typo-system)"
    />
  </svg>
);
export default Icon3DMapSizeS;
